import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { computed } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WatchLaterButton',
  props: {
  isShowButtonText: {
    type: Boolean,
    default: false
  },
  isRegisteredWatchLater: {
    type: Boolean,
    default: false
  }
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;




const textColor = computed(() => {
  return props.isRegisteredWatchLater ? "text-gray-05" : "text-primary";
});

const buttonClass = computed(() => {
  return props.isShowButtonText
    ? "button-container"
    : "button-container-simple";
});

const iconSize = computed(() => {
  return props.isShowButtonText ? "14" : "20";
});

const onChangeWatchLater = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
  emit("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(buttonClass.value),
    onClick: onChangeWatchLater
  }, [
    _createVNode(FeatherIcon, {
      icon: "paperclip",
      size: iconSize.value,
      class: _normalizeClass(textColor.value)
    }, null, 8, ["size", "class"]),
    _createTextVNode(),
    (__props.isShowButtonText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["text-size-12", textColor.value])
        }, "あとで見る", 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})